import React from 'react'

export class ScanResultProvider extends React.Component {

  constructor(props) {
    super(props)
    window.sessionStorage.setItem('analysis', '')
    window.sessionStorage.setItem('result', '')
    window.sessionStorage.setItem('scores', '')
    window.sessionStorage.setItem('printPdf', false)
    this.state = {
      analysis: {},
      result: {},
      scores: {},
      printPdf: false
    }
  }

  render() {
    return (
      <ScanResultContext.Provider
        value={{
          state: this.state,
          updateScanAnalysis: () => {
            const storedAnalysis = window.sessionStorage.getItem('analysis')
            if (storedAnalysis) this.setState({analysis: JSON.parse(storedAnalysis)})
          },
          updateScanResult: () => {
            const storedResult = window.sessionStorage.getItem('result')
            if (storedResult) this.setState({result: JSON.parse(storedResult)})
          },
          updateScores: () => {
            const storedScores = window.sessionStorage.getItem('scores')
            if (storedScores) this.setState({scores: JSON.parse(storedScores)})
          },
          showPrintView: () => {
            this.setState({printPdf: true})
          },
          hidePrintView: () => {
            this.setState({printPdf: false})
          }
        }}>
        {this.props.children}
      </ScanResultContext.Provider>
    )
  }
}

export const ScanResultContext = React.createContext()


// WEBPACK FOOTER //
// ./src/context/ScanResultContext.js